'use client'

import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'

import { useMobileNavigation } from '@maestro/commerce-blocks/providers/mobile-navigation/context'
import { useBreakpoint } from '@pearlconvert/ui/providers/breakpoint/breakpoint.context'

export const useNavigationHeaderStandard = () => {
  const { isMobileView, isDesktopView } = useBreakpoint()
  const { isOpen, closeMenu } = useMobileNavigation()
  const pathname = usePathname()
  const [lastPath, setLastPath] = useState(pathname)

  useEffect(() => {
    if (isOpen && lastPath !== pathname) {
      closeMenu()
    }

    if (lastPath !== pathname) {
      setTimeout(() => {
        const mainContent = document.querySelector(
          '#main__content'
        ) as HTMLElement
        if (mainContent) {
          mainContent.focus({ preventScroll: true })
        }
      }, 100)
    }

    setLastPath(pathname)
  }, [isOpen, pathname, lastPath, closeMenu])

  useEffect(() => {
    if (isDesktopView() && isOpen) {
      closeMenu()
    }
  }, [isDesktopView, isOpen, closeMenu])

  return {
    closeMenu,
    isMobileView: isMobileView(),
    isOpen,
  }
}
